import React, { useState } from 'react';
import defaultImg from '../../../../assets/images/default-organization.png';
import style from '../../../packs/slick_carousel_style';
import Slider from 'react-slick';
import SubscribeNow from '../shared/SubscribeNow';
import { OrganizationCard } from './cards/OrganizationCard';

export function DashboardOganizations({
	headers,
	mask_content,
	recommended_organizations,
}) {
	return (
		<div className="recommended-organizations-container">
			<div className="row">
				<div className="columns small-12">
					<h3>{headers.organizations.fields['en-US'].title}</h3>
				</div>
			</div>
			<div className="row">
				<div className="columns medium-9 small-12">
					{headers.organizations.fields['en-US'].subtitle}
				</div>
			</div>
			<div className="row">
				<div className="columns small-12 carousel-container masking-wrapper guard-for-empty">
					{mask_content ? (
						<SubscribeNow style={{ marginTop: '5rem' }} />
					) : null}

					{recommended_organizations ? (
						<Slider {...style}>
							{recommended_organizations.map((orgData, index) => {
								return (
									<OrganizationCard
										orgData={orgData}
										key={index}
										heartButtonFunction={() =>
											setOrganizationData(orgData)
										}
										params="?kind=recommended_for_you"
									/>
								);
							})}
						</Slider>
					) : (
						'When you complete your personal profile and organization profile, our AI powered recommendation engine will provide you with matches in 24 hours!'
					)}
				</div>
			</div>
		</div>
	);
}
